import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=e40130d0&scoped=true&"
import script from "./studentList.vue?vue&type=script&lang=js&"
export * from "./studentList.vue?vue&type=script&lang=js&"
import style0 from "./studentList.vue?vue&type=style&index=0&id=e40130d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40130d0",
  null
  
)

export default component.exports